import { MouseEvent } from "react";

import { analytics } from "@moodys/federated";
import { PageObj } from "@moodys/federated/types/services/analytics/types/analytics.types";
import { EventDetails } from "@moodys/federated/types/services/analytics/types/event.types";
import { AnalyticEvents } from "@moodys/federated/types/services/analytics/types/eventEmitters.types";
import {
  accountMenuLinks,
  globalPageLoaded,
  globalSubnavLinks,
  globalTopnavLinks,
  headerLogoClick,
  mdcHeaderEvents,
} from "services/analytics/Avo";

const globalNavHeaderEventDetails: EventDetails = {
  category: "GlobalNav",
  type: "Txt",
  moduleName: "Header",
};

export const useAvoTracking = () => {
  const trackAccessibeClick = () => {
    analytics.emitAnalyticsEvent(analytics.AnalyticsEvent.AvoEvent, {
      fn: mdcHeaderEvents,
      eventDetails: {
        ...globalNavHeaderEventDetails,
        name: "accessibility",
      },
    });
  };

  const trackAccountMenuClick = ({ name }: { name: string }) => {
    analytics.emitAnalyticsEvent(analytics.AnalyticsEvent.AvoEvent, {
      fn: accountMenuLinks,
      eventDetails: {
        ...globalNavHeaderEventDetails,
        id: "account menu",
        name,
      },
    });
  };

  const trackHeaderLogoClick = () => {
    analytics.emitAnalyticsEvent(analytics.AnalyticsEvent.AvoEvent, {
      fn: headerLogoClick,
      eventDetails: {
        ...globalNavHeaderEventDetails,
        type: "Img",
        name: "Home Page Logo",
      },
    });
  };

  interface RedirectLinkProps {
    mouseEventHandler: MouseEvent<HTMLAnchorElement | HTMLButtonElement>;
    newTab?: boolean;
    redirectUrl: string;
  }

  const trackMenuClick = ({
    containerLinkText,
    expansionLinkText,
    name,
    redirectLinkProps,
  }: {
    containerLinkText?: string;
    expansionLinkText?: string;
    name?: string;
    redirectLinkProps?: RedirectLinkProps;
  }) => {
    const analyticsEventDetails: AnalyticEvents = {
      fn: containerLinkText ? globalSubnavLinks : globalTopnavLinks,
      eventDetails: {
        ...globalNavHeaderEventDetails,
        siteSection: containerLinkText,
        moduleName: "Hamburger",
        depth: undefined,
        id: expansionLinkText,
        name,
      },
    };

    if (redirectLinkProps) {
      redirectLinkProps.mouseEventHandler.preventDefault();
      analytics.emitAnalyticsEvent(
        analytics.AnalyticsEvent.AvoEventWithRedirect,
        {
          ...analyticsEventDetails,
          redirectUrl: redirectLinkProps.redirectUrl,
          newTab: redirectLinkProps.newTab,
        }
      );
    } else {
      analytics.emitAnalyticsEvent(
        analytics.AnalyticsEvent.AvoEvent,
        analyticsEventDetails
      );
    }
  };

  const trackPageLoad = (pageAttributes?: Partial<PageObj>) => {
    analytics.emitAnalyticsEvent(analytics.AnalyticsEvent.AvoGlobalPageLoad, {
      fn: globalPageLoaded,
      pageDetails: {
        page: pageAttributes ?? window.digitalData?.page,
      },
    });
  };

  return {
    trackAccessibeClick,
    trackAccountMenuClick,
    trackHeaderLogoClick,
    trackMenuClick,
    trackPageLoad,
  };
};
